export const HONEYPOT_FIELD = 'm5jdls_653-';

const HoneypotField = () => (
    <>
        <label
            htmlFor={HONEYPOT_FIELD}
            aria-hidden="true"
            style={{ display: 'none' }}
        >
            Leave this field empty
        </label>
        <input
            id={HONEYPOT_FIELD}
            name={HONEYPOT_FIELD}
            type="text"
            autoComplete="new-password"
            tabIndex={-1}
            aria-hidden="true"
            style={{
                position: 'absolute',
                left: '-9999px',
                width: '1px',
                height: '1px',
                opacity: 0,
                pointerEvents: 'none',
            }}
        />
    </>
);

export default HoneypotField;
